import {CartData} from "@/app/types/CartData";
import {NEXT_SITE_URL} from "@/app/util/urlUtils";

const fetchSingleCampusCartClient = async () => {
	const cartResponse = await fetch(`${NEXT_SITE_URL}/get-user-cart`);
	try {
		const cart = await cartResponse.json();
		// no seriously typing these is going to be the worst part of everything
		return cart as CartData | null;
	} catch (err) {
		console.warn("An error occurred while fetching user cart.");
		return null;
	}
};

export default fetchSingleCampusCartClient;
